"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var loader_1 = __importDefault(require("relements/build/esm/ui/loader"));
// Actions
var BotActions_1 = require("@src/actions/BotActions");
// Constants
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
var api_1 = require("@src/api");
var BusinessManager_1 = __importDefault(require("@src/containers/BusinessManager"));
var BusinessManagerV2_1 = __importDefault(require("@src/containers/BusinessManagerV2"));
require("./BusinessManagerSwitch.scss");
var BusinessManagerSwitch = function () {
    var _a = react_1["default"].useState(undefined), pipelineVersion = _a[0], setPipelineVersion = _a[1];
    var _b = react_1["default"].useState(undefined), viaName = _b[0], setViaName = _b[1];
    var _c = react_1["default"].useState(undefined), businessId = _c[0], setBusinessId = _c[1];
    var _d = react_1["default"].useState(true), loading = _d[0], setLoading = _d[1];
    var businessIdentifier = react_router_dom_1.useParams().businessIdentifier;
    react_1["default"].useEffect(function () {
        setLoading(true);
        api_1.API.businessV2
            .getBusinessManagerVersion(businessIdentifier)
            .then(function (_a) {
            var success = _a.success, response = _a.response;
            if (!success || !response.body) {
                BotActions_1.createAlert(response.error || 'Something went wrong!', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                return;
            }
            setViaName(response.body.viaName);
            setBusinessId(response.body.id);
            setPipelineVersion(response.body.pipeline_version);
            setLoading(false);
        })["catch"](function (error) {
            api_1.captureException(error);
        });
    }, [businessIdentifier]);
    if (loading) {
        return react_1["default"].createElement(loader_1["default"], { className: "BusinessManagerSwitchLoader" });
    }
    if (pipelineVersion === 2) {
        return react_1["default"].createElement(BusinessManagerV2_1["default"], { id: businessId });
    }
    return react_1["default"].createElement(BusinessManager_1["default"], { viaName: viaName });
};
exports["default"] = BusinessManagerSwitch;
